'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';
import LeagueView from '../views/LeagueView.vue';
import LeagueManageView from '../views/LeagueManageView.vue';
import { leagueManageEventRoutes } from '../../event/routes/event-routes';
import { leagueManageSettingRoutes } from '../../setting/routes/setting-routes';
import { leagueManageSecurityRoutes } from '../../security/routes/security-routes';

// League routes
let leagueChildRoutes = [
  {
    path: '',
    name: 'league.detail',
    props: true,
    component: () => import('../views/LeagueDetailView.vue'),
  },
  {
    path: 'edit',
    name: 'league.edit',
    props: true,
    component: () => import('../views/LeagueDetailView.vue'),
  },
];

// Manage league routes
let manageChildRoutes = [
  {
    path: '',
    name: 'league.manage.detail',
    props: true,
    component: () => import('../views/LeagueManageHomeView.vue'),
  },
    {
    path: 'edit',
    name: 'league.manage.edit',
    props: true,
    component: () => import('../views/ManageLeagueEditView.vue'),
  },
];
manageChildRoutes = manageChildRoutes.concat(
  leagueManageEventRoutes,
  leagueManageSettingRoutes,
  leagueManageSecurityRoutes,
);

export const leagueRoutes = [
  {
    path: '/leagues',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'league.list',
        component: () => import('../views/LeagueListView.vue'),
      },
      {
        path: 'add',
        name: 'league.add',
        component: () => import('../views/LeagueAddView.vue'),
      },
      {
        path: ':leagueId/manage',
        component: LeagueManageView,
        props: true,
        meta: {
          layout: 'ManagementLayout',
        },
        children: manageChildRoutes,
      },
      {
        path: ':leagueId',
        component: LeagueView,
        props: true,
        children: leagueChildRoutes,
      },
    ],
  },
];
